import flatpickr from "flatpickr";
import { Lithuanian } from "flatpickr/dist/l10n/lt";
import { Russian } from "flatpickr/dist/l10n/ru";
import VLDField from "./VLD.Field";

const localeObj = {
  en: "en",
  lt: Lithuanian,
  ru: Russian
};

class VLDFieldDate extends VLDField {
  // initialiazed flatpickr object
  datePicker: any;

  public beforeMount(): VLDFieldDate {
    flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday

    this.datePicker = flatpickr(this.$field, {
      inline: true,
      closeOnSelect: true,
      monthSelectorType: "static",
      prevArrow: "&larr;",
      nextArrow: "&rarr;",
      locale: localeObj[document.body.dataset.lang] ?? "en",
      onChange: function(selectedDates, dateStr, instance) {
        instance.close();
      },
      onMonthChange: () => setTimeout(() => this.handleFocus(), 0)
    });

    const $calendarIcon = this.$field.parentElement.querySelector(
      "[data-field-calendar]"
    );
    if ($calendarIcon) {
      $calendarIcon.addEventListener("click", () => {
        this.$field.state.isFocused ? this.handleBlur() : this.handleFocus();
      });
    }

    return this;
  }
}

export default VLDFieldDate;
